import { FluxModel } from '@app/pages/Heats/HeatCalculation/Steps/heatCalculationTypes';
import {
  isAvailableAtLF,
  isFixedAdditionAmountAtLF,
  isFixedAdditionAmountAtTapping,
  isSelectedAsSource,
  isLimeSource,
  isMgOSource
} from './index';

export const filterFluxAdditional = (
  fluxes: FluxModel[],
  caoSourceName?: string,
  mgoOnlyOrDolomaSourceName?: string
): FluxModel[] => {
  return fluxes.filter(
    f =>
      isAvailableAtLF(f?.availability ?? '') &&
      !isLimeSource(f.type) &&
      !isMgOSource(f.type) &&
      !isFixedAdditionAmountAtLF(f?.availability ?? '') &&
      !isFixedAdditionAmountAtTapping(f?.availability ?? '') &&
      !isSelectedAsSource(f.name, caoSourceName, mgoOnlyOrDolomaSourceName) &&
      f.isValidAdditionalFlux === true
  );
};